import React, { createContext, useContext, useState, useCallback } from 'react';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [userData, setUserDataState] = useState(() => {
        const stored = localStorage.getItem('UserDetails');
        try {
            return stored ? JSON.parse(stored) : null;
        } catch (_) {
            return null;
        }
    });

    const login = useCallback((data) => {
        localStorage.setItem('UserDetails', JSON.stringify(data));
        setUserDataState(data);
    }, []);

    const logout = useCallback(() => {
        localStorage.removeItem('UserDetails');
        setUserDataState(null);
    }, []);

    // Patch specific fields on the user object (e.g., access_status after submitting a request)
    const updateUser = useCallback((patch) => {
        setUserDataState((prev) => {
            if (!prev) return prev;
            const updated = { ...prev, user: { ...prev.user, ...patch } };
            localStorage.setItem('UserDetails', JSON.stringify(updated));
            return updated;
        });
    }, []);

    const isAuthenticated = Boolean(userData?.access_token);
    const user = userData?.user ?? null;
    const role = user?.role ?? null;
    const isAdmin = role === 'admin';

    return (
        <AuthContext.Provider value={{ userData, user, role, isAdmin, isAuthenticated, login, logout, updateUser }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const ctx = useContext(AuthContext);
    if (!ctx) throw new Error('useAuth must be used inside AuthProvider');
    return ctx;
};

export default AuthContext;
